export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6243.5674f00f.jpg";